import { ResourceOptions } from 'react-admin';
import { FaTasks } from 'react-icons/fa';
import { Resources } from '../resource';

export { default as list } from './list';

export const name = Resources.inviteCodes;
export const icon = FaTasks;
export const options: ResourceOptions = {
  label: 'resource.inviteCodes',
};
